import { makeStyles, Spinner, tokens, type SpinnerProps } from '@fluentui/react-components';
import React from 'react';
import { customPalette } from '../../theme';

export interface ILoadingSpinnerProps extends Omit<SpinnerProps, 'label'> {
    label?: string;
}

const useStyles = makeStyles({
    loadingSpinnerLabel: {
        color: customPalette.themePrimary,
        fontWeight: tokens.fontWeightRegular,
        fontSize: tokens.fontSizeBase200,
    },
});

const LoadingSpinner: React.FC<ILoadingSpinnerProps> = ({ delay = 250, labelPosition = 'before', label, ...rest }) => {
    const styles = useStyles();

    return (
        <Spinner
            aria-live='polite'
            role='status'
            size='small'
            label={{ children: label, className: styles.loadingSpinnerLabel }}
            labelPosition={labelPosition}
            delay={delay}
            {...rest}
        />
    );
};

export default LoadingSpinner;
